import clsx from "clsx";

import styles from "./DateModal.module.css";

interface AlldayToggleProps {
  isAllDay: boolean;
  handleIsAllDay: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AlldayToggle: React.FC<AlldayToggleProps> = ({ isAllDay, handleIsAllDay }) => {
  return (
    <label
      className={clsx("alldayToggle", {
        [styles["toggle_container"]]: !isAllDay,
        [styles["toggle_container--selected"]]: isAllDay,
      })}
    >
      <div className={styles.toggle}>
        <input
          type="checkbox"
          checked={isAllDay}
          onChange={handleIsAllDay}
        />
        <span className={styles.slider}></span>
      </div>
      <span className={styles.toggle_label}>All day</span>
    </label>
  );
};

export default AlldayToggle;
